<template>
  <div>
    <h3>Buyout Requests</h3>

    <b-alert show>
      <p>Review pending and completed buyout requests.</p>

      <p><strong>Note:</strong> Buyout requests need to be approved approximately 3 months ahead of the start of the semester the buyout is requested. Approval will require the status of ‘confirmed’ by the Research Advancement team followed by ‘approved’ by the Faculty Success team.</p>
    </b-alert>

    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search" debounce="500"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>

    <b-table striped
             hover
             :items="buyoutRequests"
             :fields="fields"
             :per-page="perPage"
             :current-page="currentPage"
             sort-by="name"
             :filter="filter"
             :filter-function="filterItems"
             @filtered="onFiltered"
             responsive
             show-empty>
      <template v-slot:cell(workload.timePeriod.description)="data">
        {{ data.item.workload.timePeriod.description }}
      </template>
      <template v-slot:cell(employee.fullName)="data">
        {{ data.item.employee.fullName }} 
      </template>
      <template v-slot:cell(currentStatus.statusName)="data">
        {{ data.item.currentStatus.statusName }} ( {{ data.item.currentStatus.createdDate | formatDateTime }} )
      </template>
      <template v-slot:cell(createdDate)="data">
        {{ data.item.createdDate | formatDateTime }}
      </template>
      <template v-slot:cell(grants)="data">
        <div v-for="(grant, index) in data.item.grants" :key="index">
          {{ grant.description }}
        </div>
      </template>
      <template v-slot:cell(details)="data">
        <router-link :to="{ name: 'buyoutRequestDetails', params: { id: data.item.id } }">Details</router-link>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import buyoutRequestApi from "../../api/buyouts";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],

  data() {
    return {
      filter: null,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      fields: [
        {
          key: "workload.timePeriod.description",
          sortable: true,
          label: "Year",
        },
        { key: "term.description", label: "Semester", sortable: true },
        { key: "employee.fullName", sortable: true, label: "Faculty" },
        { key: "numberOfClasses", sortable: true, label: "Number Of Classes" },
        { key: "grants", sortable: true },
        { key: "createdDate", sortable: true, label: "Date Submitted" },
        { key: "currentStatus.statusName", sortable: true, label: "Status" },
        { key: "details", label: "" },
      ],
      buyoutRequests: [],
    };
  },

  methods: {
    filterItems(dataObject) {
      var matchedFilter = this.matchFilter(dataObject, this.filter);

      if (matchedFilter) {
        return true;
      }
      return false;
    },

    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },

    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },

    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },

  created() {
    buyoutRequestApi
      .getBuyouts()
      .then((response) => {
        this.buyoutRequests = response.data;
        this.totalRows = this.buyoutRequests.length;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
};
</script>

<style>
</style>
